import styled, { css } from 'styled-components';

import { StrongText, Text, TooltipLabel } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { translationKeys } from '../../translations';

type StyledReimbursementTooltipContentProps = {
   shouldNumbered: boolean;
};

const StyledReimbursementTooltipContent = styled.ol<StyledReimbursementTooltipContentProps>`
   margin: 0;
   ${(props) => css`
      padding-inline-start: ${props.shouldNumbered ? '1.2em' : '0'};
      list-style-type: ${props.shouldNumbered ? 'decimal' : 'none'};
   `}
`;

StyledReimbursementTooltipContent.displayName = 'StyledReimbursementTooltipContent';

export type ReimbursementTooltipContent = {
   description: string;
   distinct: boolean;
};
type ReimbursementTooltipContentProps = {
   readonly tooltipContent: ReimbursementTooltipContent[] | string[] | string;
};

export const ReimbursementTooltipContent = (props: ReimbursementTooltipContentProps): JSX.Element => {
   const extendedDatabaseMedicineAvailable = protectFeature('extendedMedicineDatabase');

   if (typeof props.tooltipContent === 'string') {
      return (
         <StyledReimbursementTooltipContent shouldNumbered={false}>
            {props.tooltipContent}
         </StyledReimbursementTooltipContent>
      );
   }

   const shouldNumbered = props.tooltipContent.length > 1;
   const tooltipContent = props.tooltipContent?.map((content) =>
      typeof content === 'string' ? { description: content, distinct: false } : content
   );

   return (
      <StyledReimbursementTooltipContent shouldNumbered={shouldNumbered}>
         <TooltipLabel label={translationKeys.reimbursementIndications} />
         {tooltipContent.map((content) => (
            <li key={content.description}>
               {content.distinct && extendedDatabaseMedicineAvailable ? (
                  <StrongText testId={content.description}>{content.description}</StrongText>
               ) : (
                  <Text testId={content.description}>{content.description}</Text>
               )}
            </li>
         ))}
      </StyledReimbursementTooltipContent>
   );
};
